import styled, { CSSProperties } from "styled-components";

type FlexProps = {
  align?: CSSProperties["alignContent"];
  justify?: CSSProperties["justifyContent"];
  direction?: CSSProperties["flexDirection"];
  gap?: CSSProperties["gap"];
};
export const Flex = styled.div<FlexProps>`
  display: flex;
  gap: ${({ gap }) => (gap ? gap : "unset")};
  align-items: ${({ align }) => (align ? align : "center")};
  justify-content: ${({ justify }) => (justify ? justify : "center")};
  flex-direction: ${({ direction }) => (direction ? direction : "row")};
  > span {
    width: 100%;
  }
`;

type GridProps = {
  columns?: CSSProperties["gridTemplateColumns"];
  gap?: CSSProperties["gap"];
};
export const Grid = styled.div<GridProps>`
  display: grid;
  gap: ${({ gap }) => (gap ? gap : "unset")};
  grid-template-columns: ${({ columns }) => (columns ? `repeat(${columns}, 1fr)` : "unset")};
`;
